import React, { useEffect, useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';

import {
    LinearProgress,
    Grid,
    Container
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    TableDetails,
    TableForm
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';
import { ToastContext } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    container: {
        marginTop: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getTableAsync,
        toggleTableAvailabilityAsync,
        toggleTableAllowImportAsync,
        toggleTableClearOnImportAsync,
        updateTableAsync
    } = useContext(PageContext);

    const {
        navigateTo,
        goBack
    } = useContext(NavContext);

    const {
        showSuccessMessage,
    } = useContext(ToastContext);

    const {
        table
    } = state;

    const manageUsersHandler = (e) => {
        navigateTo(NavRoutes.Admin.TableUsers, [table.managedTableId]);
    }

    const formRef = useRef();
    const saveTableHandler = (e) => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const tableFormSubmitHandler = async (values, done) => {
        setIsBusy({ updating: true });
        await updateTableAsync({
            tableId: parseInt(tableId),
            ...values
        });
        done();
        showSuccessMessage("Your changes have been saved");
        setIsBusy({ updating: false });
    }

    const cancelHandler = (e) => {
        goBack();
    }

    // const toggleAvailabilityHandler = async (table) => {
    //     setIsBusy({ toggleTable: true });
    //     await toggleTableAvailabilityAsync({
    //         tableId: table.managedTableId,
    //         isDisabled: !table.isDisabled
    //     });
    //     setIsBusy({ toggleTable: false });
    // }

    // const toggleAllowImportHandler = async (table) => {
    //     setIsBusy({ toggleTable: true });
    //     await toggleTableAllowImportAsync({
    //         tableId: table.managedTableId,
    //         allowImport: !table.allowImport
    //     });
    //     setIsBusy({ toggleTable: false });
    // }

    // const toggleClearOnImportHandler = async (table) => {
    //     setIsBusy({ toggleTable: true });
    //     await toggleTableClearOnImportAsync({
    //         tableId: table.managedTableId,
    //         clearOnImport: !table.clearOnImport
    //     });
    //     setIsBusy({ toggleTable: false });
    // }

    const { tableId } = useParams();
    useEffect(() => {
        if (tableId) {
            getTableAsync(parseInt(tableId), true);
        }
    }, [tableId]);

    useEffect(() => {
        setPageIsReady(table !== null)
    }, [table])

    return (
        <>
            {pageIsReady ?
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            cancel
                            action1
                            action1ButtonText="Manage users"
                            title={table.tableName}
                            subtitle="Table details"
                            disabled={isBusy()}
                            onAction1Click={manageUsersHandler}
                            onSaveClick={saveTableHandler}
                            onCancelClick={cancelHandler}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Container maxWidth="lg" className={classes.container}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TableForm
                                        formRef={formRef}
                                        disabled={isBusy()}
                                        onSubmit={tableFormSubmitHandler}
                                    />
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const TablePage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}